var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.98 43.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-A8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1297086987040",
    "data-name": 1297086987040
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,37.15a3.71,3.71,0,0,1,3.1-5.4,2.75,2.75,0,0,1,1,.26,3,3,0,0,1,1.26,3.4,4,4,0,0,1-1.14,1.92C15.43,38.6,13.33,38.62,12.5,37.15Zm3.34-17.92c.36.64-.65,1.41-1.1.61S15.46,18.55,15.84,19.23ZM20.64.08a5.81,5.81,0,0,0-.74,1.17c-.22.42-.3.85-.47,1.25L18.32,5.64c-.07.25-.15.37-.23.63l-3.16,8.89c-.21.7-1.8,4.9-1.76,5.09s1.32,1.09,1.54,1.35.16.43.19.67l.29,4.06c.05.44,0,.88.07,1.35l.24,2.72A5.44,5.44,0,0,0,12.2,32C9.45,34.91,11,39.3,14.06,39.54c1.8.14,1.9,3,2.41,3.36l.48.16a.85.85,0,0,0,.63-.14c-.06-.75-1-2.88-.34-4.19a1.82,1.82,0,0,1,.49-.55c1.7-1.63,2.23-4.81.45-6.61-.72-.73-.47-.45-.6-2l-.22-2.82c-.06-.47-.05-.89-.11-1.42l-.32-4.23a7.29,7.29,0,0,1,0-1.39l.38-2c0-.23.07-.44.12-.65.34-1.39,1.19-6.13,1.45-7.51.43-2.32,1-5.65,1.5-7.87L20.63.07Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19,33.48a3.61,3.61,0,0,1-1,.32,2.35,2.35,0,0,1-2.53-1.41c-1.48-2.62,1.46-6.38,3.9-5S7.27,32.3,5.19,33.48ZM.51,33l0,0a5.16,5.16,0,0,1,2-6.59,5.08,5.08,0,0,1,1.41-.5,3.3,3.3,0,0,1,1.27,0,58.32,58.32,0,0,0,4.69-3.59l2.34-1.85c.33.22.62.5,1,.77,1.21,1,1,.74.32,1.18L7,26.81A4.33,4.33,0,0,1,8.3,29.57a3.13,3.13,0,0,1,0,.53,1.49,1.49,0,0,1,0,.52c0,.14-.09.41,0,.53a1.19,1.19,0,0,1,.51,1.3c-.37,1-1.19.46-1.54.85a4.28,4.28,0,0,1-2.93,1.78A3.62,3.62,0,0,1,.51,33Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,19.6c.17-.34.35-.65.54-1l3.85-7.31c.4-.7.71-1.39,1.09-2.09s.72-1.37,1.1-2.08L25.94,4a6.18,6.18,0,0,0,0-1.22h0L23,6.71c-.22.32-.47.64-.69,1l-2.54,3.48c-.13.19-.19.31-.33.5-.38.48-.45.48-.54,1.07-.05.38-.16.72-.22,1.11l-.87,4.58a2.78,2.78,0,0,0-.14,1.19Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.63 0.08 20.69 0.05 20.6 0 20.63 0.08",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA8);
export default __webpack_public_path__ + "static/media/A8.57bda5050207d1fb3a284f21c9efb7ab.svg";
export { ForwardRef as ReactComponent };